import './Layout.scss';
import Navbar from '@/components/Navbar.tsx';
import {Outlet} from 'react-router';

export function Layout() {
	return (
		<>
			<Navbar />

			<div className="page-content">
				<Outlet />
			</div>
		</>
	);
}
